<template>
    <v-card class="cardWrap">
        <CardTitle title="プラン一覧" />
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
            class="elevation-1">
            <template v-slot:top>
                <v-form ref="form" lazy-validation>
                    <v-container>
                        <!-- <v-toolbar flat color="white" class="mt-1"> -->
                            <v-row no-gutters>
                                <v-col cols="3">
                                    <v-select
                                        class="mr-3 pt-4"
                                        v-model="golfCode"
                                        :items="golfSelect"
                                        item-value="golf_code"
                                        item-text="golf_name"
                                        label="ゴルフ場名"
                                    />
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        class="mr-3 pt-4"
                                        v-model="planName"
                                        label="プラン名"
                                        single-line
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-checkbox
                                    class="mr-3"
                                    v-for="d in displayMemberClass"
                                    :key="d.id"
                                    :label="d.code_name"
                                    :value="d.code"
                                    v-model="PlanMemberClass"
                                />
                            </v-row>
                            <v-row no-gutters>
                                <!-- <v-col> -->
                                    <v-checkbox class="mr-3" v-model="shareFlag" label="シェア予約" value="1"/>
                                    <v-checkbox class="mr-3" v-model="requestFlag" label="リクエスト予約" value="1"/>
                                <!-- </v-col> -->
                                <v-col cols="3" class="searchBtn">
                                    <v-btn
                                        :disabled="btn[1].isActive"
                                        color="primary"
                                        class="ml-5"
                                        @click="clickSearch"
                                        large
                                    >検索</v-btn>
                                </v-col>
                            </v-row>
                        <!-- </v-toolbar> -->
                    </v-container>
                </v-form>
            </template>
            <template v-slot:[`item.detail`]="{ item }">
                <v-btn
                    :disabled="btn[2].isActive"
                    color="green darken-4"
                    small
                    text
                    @click="PlanDetailChangeDialog(item)">詳細</v-btn>
            </template>
            <template v-slot:[`item.setting`]="{ item }">
                <v-btn
                    :disabled="btn[3].isActive"
                    color="green darken-4"
                    small
                    text
                    @click="PlanCellSettingListDialog(item)">枠連携</v-btn>
            </template>
            <template v-slot:[`item.cell`]="{ item }">
                <v-btn
                    :disabled="btn[6].isActive"
                    color="green darken-4"
                    small
                    text @click="PlanCellListDialog(item)">料金連携</v-btn>
            </template>
            <template v-slot:[`item.copy`]="{ item }">
                <v-btn
                    :disabled="btn[4].isActive"
                    color="green darken-4"
                    small
                    text
                    @click="copyPlanInfo(item)">コピー</v-btn>
            </template>
        </v-data-table>
        <v-pagination
            class="my-2"
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            @input="clickPagination"
        ></v-pagination>
        <v-spacer></v-spacer>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[5].isActive"
                color="primary"
                @click="PlanDetailAddDialog()"
                >追加</v-btn>
        </v-card-actions>
        <PlanDetail
            :dialog="planDialog"
            :golfSelectProps="golfSelect"
            @close="closeChild"
            ref="Detail"
        />
        <PlanCellsFeeSetting
            :dialog="planCellDialog"
            :golfCourseProps="passGolfCourseToChild"
            :golfSelectProps="golfSelect"
            :propsPlanName="passPlanNameToChild"
            :propsPlanId="passPlanIDToChild"
            @close="closeChild"
            ref="child"
        />
        <PlanCellReleaseSetting
            :dialog="planCellSettingDialog"
            :golfCourseCode="passGolfCourseToChild"
            :golfSelectProps="golfSelect"
            :propsPlanName="passPlanNameToChild"
            :propsPlanId="passPlanIDToChild"
            @close="closeChild"
        />
    </v-card>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
// モーダル
import PlanDetail from './dialog/PlanDetail';
import PlanCellsFeeSetting from './dialog/PlanCellsFeeSetting';
import PlanCellReleaseSetting from './dialog/PlanCellReleaseSetting';
// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { golfCourseMixin } from '@/mixins/golfCourse';
import { codeListMixin } from '@/mixins/codeList';
// graghql
import {
    GET_PLAN_LIST,
    REGIST_PLAN_MASTER,
    COPY_PLAN_MASTER } from '@/constants/plan';

export default {
    components: {
        CardTitle,
        PlanDetail,
        PlanCellsFeeSetting,
        PlanCellReleaseSetting
    },
    mixins: [
        authorityMixin,
        golfCourseMixin,
        codeListMixin
    ],
    data () {
        return {
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: 'プランコード', value: 'plan_id', sortable: false },
                { text: 'プラン名', value: 'plan_name', sortable: false },
                { text: '優先度', value: 'display_priority', align: 'left', sortable: false },
                { text: '', align: 'center', value: 'detail', sortable: false, width: '150' },
                { text: '', align: 'center', value: 'setting', sortable: false, width: '150' },
                { text: '', align: 'center', value: 'cell', sortable: false, width: '150' },
                { text: '', align: 'center', value: 'copy', sortable: false, width: '150' }
            ],
            // プランID 子に渡すデータ
            passPlanIDToChild: '',
            // プランネーム 子に渡すデータ
            passPlanNameToChild: '',
            // ゴルフ場選択の制御 子に渡すデータ
            modeStatus: '',
            // ゴルフ場コード 子に渡すデータ
            passGolfCourseToChild: '',
            // 子のダイアログの状態 trueにすると表示
            planDialog: false,
            // 子のダイアログの状態 trueにすると表示
            planCellDialog: false,
            // 子のダイアログの状態 trueにすると表示
            planCellSettingDialog: false,
            // ゴルフグループ
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // チェックボックス
            displayMemberClass: [],
            // ゴルフ場セレクトボックス
            golfSelect: [],
            // 検索キーワード
            golfCode: '',
            // 検索キーワード
            passGolfName: '',
            // 検索キーワード
            planName: '',
            // 検索キーワード
            PlanMemberClass: [],
            // 検索キーワード
            shareFlag: null,
            // 検索キーワード
            requestFlag: null,
            page: 1,
            pageCount: 0,
            // offset
            beginRow: 0,
            // 一覧の最大表示値
            limitRows: 10,
            // ログインしている者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: false },
                { element_id: '001', element_name: '検索', isActive: false },
                { element_id: '002', element_name: '詳細', isActive: false },
                { element_id: '003', element_name: '枠設定', isActive: false },
                { element_id: '004', element_name: 'コピー', isActive: false },
                { element_id: '005', element_name: '追加', isActive: false },
                { element_id: '006', element_name: '料金連携', isActive: false }
            ],
            vue_id: 'SCR0024'
        };
    },
    async created () {
        this.$store.commit('loading/setIsLoading', true);
        this.displayMemberClass = await this.getCodeList('display_member_class');
        this.admin = await this.getLoginAdmin();
        this.golfSelect = await this.getGolfCourseList();
        this.golfCode = this.golfSelect[0].golf_code;
        this.getAuthorityList();
        this.getPlanList();
        this.$store.commit('loading/setIsLoading', false);
    },
    watch: {
        golfCode () {
            const currentGolfCourse = this.golfSelect.find(el => el.golf_code === this.golfCode);
            this.passGolfName = currentGolfCourse.golf_name;
        }
    },
    methods: {
        /** --------------------------------------------
        * プラン一覧情報を取得
        * -------------------------------------------- */
        getPlanList () {
            this.$apollo.query({
                query: GET_PLAN_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.golfCode,
                    plan_name: this.planName,
                    plan_member_class: this.PlanMemberClass,
                    share_flag: this.shareFlag,
                    request_flag: this.requestFlag,
                    offset: this.beginRow,
                    limit: this.limitRows
                }
            }).then(res => {
                this.desserts = res.data.getPlanListFromAdmin.PlanList;
                const count = res.data.getPlanListFromAdmin.count;
                this.pageCount = Math.ceil(count / this.limitRows);
                this.passGolfCourseToChild = this.golfCode;
            });
        },
        /** ----------------------------------------------
         * 登録処理
         * ---------------------------------------------- */
        registPlanMaster () {
            return this.$apollo.mutate({
                mutation: REGIST_PLAN_MASTER,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.golfCode
                }
            }).then(res => {
                const result = res.data.registPlanMaster.result;
                this.passPlanIDToChild = res.data.registPlanMaster.planId;
                if (result === 1) {
                    return result;
                } else {
                    throw new Error('エラーが発生しました。');
                }
            }).catch(error => {
                this.error = error;
            });
        },
        /** --------------------------------------------
        * プランをコピーする
        * -------------------------------------------- */
        copyPlanInfo (data) {
            let result = confirm('プラン情報をコピーします。');
            if (result) {
                this.$apollo.mutate({
                    mutation: COPY_PLAN_MASTER,
                    variables: {
                        plan_id: data.plan_id
                    }
                }).then(res => {
                    return res.data.copyPlanMaster.result;
                }).finally(res => {
                    this.getPlanList();
                });
            }
        },
        /** --------------------------------------------
        * ページネーション処理
        * -------------------------------------------- */
        clickPagination () {
            this.beginRow = this.page * this.limitRows - this.limitRows;
            this.getPlanList();
        },
        /** --------------------------------------------
        * 検索ボタン処理
        * -------------------------------------------- */
        clickSearch () {
            this.page = 1;
            this.beginRow = 0;
            this.getPlanList();
        },
        /** --------------------------------------------
        * プラン詳細画面を追加モードで開く
        * -------------------------------------------- */
        async PlanDetailAddDialog () {
            const result = await this.registPlanMaster();
            if (result === 1) {
                this.planDialog = true;
                this.$refs.Detail.ModalControl(
                    this.passPlanIDToChild,
                    this.golfCode,
                    this.passGolfName,
                    'addMode');
            }
        },
        /** --------------------------------------------
        * プラン詳細画面を変更モードで開く
        * -------------------------------------------- */
        PlanDetailChangeDialog (data) {
            this.planDialog = true;
            this.$refs.Detail.ModalControl(
                data.plan_id,
                this.golfCode,
                this.passGolfName,
                'changeMode');
        },
        /** --------------------------------------------
        * 枠情報画面を開く
        * -------------------------------------------- */
        PlanCellListDialog (data) {
            this.passPlanIDToChild = data.plan_id;
            this.passGolfCourseToChild = this.golfCode;
            this.passPlanNameToChild = data.plan_name;
            this.planCellDialog = true;
        },
        /** --------------------------------------------
        * 料金設定画面を開く
        * -------------------------------------------- */
        PlanCellSettingListDialog (data) {
            this.passPlanIDToChild = data.plan_id;
            this.passGolfCourseToChild = this.golfCode;
            this.passPlanNameToChild = data.plan_name;
            this.planCellSettingDialog = true;
        },
        /** --------------------------------------------
        * 子コンポーネントを閉じる
        * -------------------------------------------- */
        closeChild () {
            this.modeStatus = 'close';
            this.planId = '';
            this.passPlanIDToChild = '';
            this.passPlanNameToChild = '';
            this.planCellSettingDialog = false;
            this.planCellDialog = false;
            this.planDialog = false;
            this.getPlanList();
        }
    }
};
</script>

<style>
.point_select {
  color: black;
  background: Transparent;
  text-decoration: underline;
}

.selectWidth {
    width: 180px;
}

.v-input--selection-controls{
    margin-top: 10px;
}

.searchBtn{
    margin: 0 0 0 auto;
}

.container{
    padding: 0 12px;
}

.v-input__slot{
    margin-bottom: 5px;
}

</style>
